module.exports = __webpack_public_path__ + "img/04-3-4协同合作.dd05835f.svg";